import { render } from "./Certificate.vue?vue&type=template&id=5903e7ab&scoped=true"
import script from "./Certificate.vue?vue&type=script&lang=js"
export * from "./Certificate.vue?vue&type=script&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=5903e7ab&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3857685418/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5903e7ab"]])

export default __exports__